<template>
    <SvgComponent :width="size" :height="size" viewBox="0 0 20 20" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM6.96963 6.96965C7.26252 6.67676 7.73739 6.67676 8.03029 6.96965L9.99997 8.93933L11.9696 6.96967C12.2625 6.67678 12.7374 6.67678 13.0303 6.96967C13.3232 7.26256 13.3232 7.73744 13.0303 8.03033L11.0606 9.99999L13.0303 11.9696C13.3232 12.2625 13.3232 12.7374 13.0303 13.0303C12.7374 13.3232 12.2625 13.3232 11.9696 13.0303L9.99997 11.0607L8.03031 13.0303C7.73742 13.3232 7.26254 13.3232 6.96965 13.0303C6.67676 12.7374 6.67676 12.2625 6.96965 11.9697L8.93931 9.99999L6.96963 8.03031C6.67673 7.73742 6.67673 7.26254 6.96963 6.96965Z" fill="white"/>
        <path d="M8.03029 6.96965C7.73739 6.67676 7.26252 6.67676 6.96963 6.96965C6.67673 7.26254 6.67673 7.73742 6.96963 8.03031L8.93931 9.99999L6.96965 11.9697C6.67676 12.2625 6.67676 12.7374 6.96965 13.0303C7.26254 13.3232 7.73742 13.3232 8.03031 13.0303L9.99997 11.0607L11.9696 13.0303C12.2625 13.3232 12.7374 13.3232 13.0303 13.0303C13.3232 12.7374 13.3232 12.2625 13.0303 11.9696L11.0606 9.99999L13.0303 8.03033C13.3232 7.73744 13.3232 7.26256 13.0303 6.96967C12.7374 6.67678 12.2625 6.67678 11.9696 6.96967L9.99997 8.93933L8.03029 6.96965Z" fill="#242425"/>
    </SvgComponent>
</template>

<script>
import SvgComponent from '../ui/svg-component.vue';

export default {
    components: {
        SvgComponent
    },
    props: {
        size: {
            type: [String, Number],
            default: 20
        },
    }
}
</script>
